var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from '@mui/material';
import { inject, observer } from 'mobx-react';
import React from 'react';
import OutlineContainer from '../custom-fields/outline';
var CustomFieldLineBreak = /** @class */ (function (_super) {
    __extends(CustomFieldLineBreak, _super);
    function CustomFieldLineBreak(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(CustomFieldLineBreak.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var label = this.props.isEditMode ? _jsx(OutlineContainer, { children: "Line Break" }, void 0) : _jsx("span", {}, void 0);
            return (_jsx(Grid, __assign({ container: true, alignItems: "center", justifyContent: "center" }, { children: label }), void 0));
        }
    });
    CustomFieldLineBreak = __decorate([
        inject('fieldsStore'),
        observer
    ], CustomFieldLineBreak);
    return CustomFieldLineBreak;
}(React.Component));
export default CustomFieldLineBreak;
